module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAwElEQVR4AdXMtVlEQRhG4dsCTVAVDZDiTkQHuLu7Q4S7u9u6u8vZydY1urzzfNn8R5KHq6JiCpmMAiSw+d2YvE5iOQNerD43MdIHtlQPvNm03Jh+8YeCADxaVNRfznJr+ksf8AYDrCluaXvcpuFynvKzSYLhEGq3lZqLGUp2u5j+OksdcAd9VJ1PU34yRr343Hy1QMvtChpxvKt5pXS/j8areYbfDwmIaFLAEfByYfzG4fcQKyxeOlIMCpjMAv9YBFMHgbsBCMlIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IQ.png
// module id = 1170
// module chunks = 0